import { createSlice } from '@reduxjs/toolkit'

import { getAllLeagues, deleteLeague } from './actions'
import { State } from './types'

const initialState: State = {
  isLoading: false,
  leagues: [],
  error: null,
}

const leagueSlice = createSlice({
  name: 'league',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllLeagues.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(getAllLeagues.fulfilled, (state, { payload }) => {
        state.isLoading = false
        state.leagues = payload
      })
      .addCase(getAllLeagues.rejected, (state, action) => {
        if (action.payload) {
          state.error = action.payload.errors
        } else {
          state.error = action.error.message
        }
      })
      .addCase(deleteLeague.fulfilled, (state, { meta }) => {
        state.leagues = state.leagues.filter(
          (l: any) => l._id !== meta.arg.leagueId
        )
      })
  },
})

export const { reducer, actions } = leagueSlice

export default leagueSlice
